import { useState, useEffect, useCallback } from 'react';
import supabase from '../supabase';

export const useVenues = () => {
  const [venues, setVenues] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Load venues from Supabase
  const loadVenues = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      
      const { data, error } = await supabase
        .from('venues')
        .select('*')
        .order('name');

      if (error) {
        console.error('Error fetching venues:', error);
        setError(error.message);
        return [];
      }

      console.log('Loaded venues:', data);
      setVenues(data || []);
      return data || [];
    } catch (err) {
      console.error('Error loading venues:', err);
      setError(err.message);
      return [];
    } finally {
      setLoading(false);
    }
  }, []);

  // Load venues on hook initialization
  useEffect(() => {
    loadVenues();
  }, [loadVenues]);

  return {
    venues,
    loading,
    error,
    loadVenues
  };
};
